import React from 'react';
import { useDispatch } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import MainContainer from 'src/containers/main-container/MainContainer';
import { appInitAction } from 'src/containers/app-container/actions/AppActions';
import LoginForm from './containers/auth-container/login/LoginForm';
import PrivateRoute from './hoc/PrivateRouteHOC';
import HeaderContainer from './containers/header-container/HeaderContainer';

export default () => {
    const dispatch = useDispatch();
    dispatch(appInitAction());

    return (
        <BrowserRouter>
            <>
                <HeaderContainer />
                <Switch>
                    <Route
                        exact
                        path="/login"
                        component={LoginForm}
                    />

                    <PrivateRoute
                        path="/"
                        component={MainContainer}
                    />
                </Switch>
            </>
        </BrowserRouter>
    );
};
